import React, { useEffect, useState, useRef } from 'react';

export default function IconArrow() {
  return (
    <svg viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 2L8 8L15 2" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}